import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "The reservation violates some rules:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Please press \"Proceed Anyway\" if this is correct.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }),
            _createVNode(_component_ion_title, { style: {"font-family":"'San Francisco', sans-serif","font-weight":"700","text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode("Warning - Rules")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-no-padding",
      style: {"--background":"rgb(239, 246, 255)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name
                  }, [
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.errors, (error) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: error.id
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_grid, { class: "ldx-bottom-fixed" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px","--border-width":"2px","--border-style":"solid"},
                      color: "danger",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px","--border-width":"2px","--border-style":"solid"},
                      color: "primary",
                      size: "medium",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Proceed Anyway")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}